var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isMobile)?_c('div',{attrs:{"id":"app"}},[_c('router-view')],1):_c('div',[_vm._v(" Извините, этот сайт доступен только с мобильных устройств. ")])
}
var staticRenderFns = []

export { render, staticRenderFns }